import { render, staticRenderFns } from "./Logins.vue?vue&type=template&id=28d3280b&scoped=true"
import script from "./Logins.vue?vue&type=script&lang=js"
export * from "./Logins.vue?vue&type=script&lang=js"
import style0 from "./Logins.vue?vue&type=style&index=0&id=28d3280b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3280b",
  null
  
)

export default component.exports